import {css} from "styled-components"

import {SpacingProps, SizingProps, spacingCss, sizingCss} from "../../../global/css"

export const mainStyles = css<SpacingProps & SizingProps>`
  ${({theme}) => `
    font-family: ${theme.font.default};
    color: ${theme.colors.utility.ink};
    margin: 0;
    padding: 0;
  `}
  ${spacingCss}
  ${sizingCss}
`

export const h1 = css`
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0;
  font-family: ${({theme}) => theme.font.semibold};

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    font-size: 32px;
    line-height: 40px;
  `}
`

export const h2 = css`
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0;
  font-family: ${({theme}) => theme.font.bold};
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    font-family: ${theme.font.semibold};
  `}
`

export const h3 = css`
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0;
  font-family: ${({theme}) => theme.font.bold};

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    line-height: 24px;
  `}
`

export const h4 = css`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
  font-family: ${({theme}) => theme.font.bold};
`

export const h5 = css`
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  font-family: ${({theme}) => theme.font.bold};
`

export const h6 = css`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
  text-transform: none;
  font-family: ${({theme}) => theme.font.bold};
`
